export default __webpack_public_path__ + "static/media/photo--sm--129.a4499d93.jpg";